import type { CardHooks } from "./registry";

/** Dance of Blades — for each damage taken, +1 block to next action. */
export const danceOfBlades: CardHooks = {
  onDamageTaken: (ctx) => {
    if (!ctx.damageTaken) return {};
    return {
      selfPatch: {
        pendingBuffs: [
          ...ctx.self.pendingBuffs,
          {
            id: `dob_${Math.random().toString(36).slice(2, 9)}`,
            sourceCardName: "Dance of Blades",
            trigger: "next-action",
            effect: { kind: "block-bonus", amount: ctx.damageTaken },
            createdRound: ctx.game.round,
          },
        ],
      },
      log: [`Dance of Blades — +${ctx.damageTaken} block on next action`],
    };
  },
};
